import { render, staticRenderFns } from "./SnsTagForm.vue?vue&type=template&id=9088653a&"
import script from "./SnsTagForm.vue?vue&type=script&lang=js&"
export * from "./SnsTagForm.vue?vue&type=script&lang=js&"
import style0 from "./SnsTagForm.vue?vue&type=style&index=0&id=9088653a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports